const state = {
  token: '',
  userId: '',
  phone: ''
}

const getters = {}

const mutations = {
  setoken(state, data) {
    state.token = data
  },
  setuser(state, data) {
    state.userId = data
  },
  setphone(state, data) {
    state.phone = data
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js